const VALID_DAY_STATUSES = new Set([
  'completed',
  'missed',
  'today_pending',
  'future',
]);

const toNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

const toNullableString = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export function normalizeUserStreak(raw) {
  if (!raw) return null;

  return {
    currentCount: toNumber(raw.currentCount),
    longestCount: toNumber(raw.longestCount),
    lastActivityDate: toNullableString(raw.lastActivityDate),
    today: toNullableString(raw.today),
    isActiveToday: Boolean(raw.isActiveToday),
    isExpired: Boolean(raw.isExpired),
    weekTracker: Array.isArray(raw.weekTracker)
      ? raw.weekTracker.map((day) => ({
          date: String(day?.date || ''),
          dayLabel: String(day?.dayLabel || ''),
          status: VALID_DAY_STATUSES.has(day?.status) ? day.status : 'future',
        }))
      : [],
  };
}
